import { useStore, withStore } from 'store';
import { Tabs } from 'components';
import AddressSection from 'pages/TableFlow/Address';
import { updateGiftTable } from 'store/actions/giftTable';
import { PLAN_TYPES } from 'constants/catalogs/planTypes';
import { useStorage64 } from 'hooks';
import { SEND_DIRECTIONS } from 'constants/storage64';
import Message from '../Message';
import { withAgentPage } from 'hocs';
import compose from 'recompose/compose';

let agentStaffToken = null;

function Address() {
  const [addressId, dispatch] = useStore(
    (state) => state.giftTable.giftTableInfo.data.customer.address_id
  );

  const [tableInfo] = useStore(
    (state) => state.giftTable.giftTableInfo.data
  );

  const handleSaveData = (address) => {
    const data = {
      address: {
        address_id: address.id,
        name: address.nombre,
        street: address.calle,
        number: address.numeroExterior,
        internal_number: address.numeroInterior || null,
        suburb: address.colonia,
        zip_code: address.codigoPostal,
        state: address.estado,
        city: address.ciudad,
        town: address.municipio,
        references: address.referencias,
        between_streets: address.entreCalles,
        phone: address.telefono,
        withLoader: true
      }
    }
    dispatch(updateGiftTable(data));
  };

  const [directions] = useStorage64(SEND_DIRECTIONS);

  return (
    <AddressSection
      showBottomBar={false}
      onSaveData={handleSaveData}
      handleNext={() => {}}
      currentAddress={directions?.address.find((x) => x.id === addressId)}
      onlyView={tableInfo?.status !== 'Open'}
      agentStaffToken={agentStaffToken}
      addressId={addressId}
    />
  );
}

const LIST_OF_SECTIONS = [
  {
    id: 'message',
    title: 'MENSAJE',
    Section: Message,
  },
  {
    id: 'address',
    title: 'DIRECCIÓN',
    Section: Address,
  },
];

function Customization({ tableInfo, queryAgentToken }) {
  agentStaffToken = queryAgentToken;
  return (
    <div className="py-4">
      {tableInfo?.plan?.id === PLAN_TYPES.GIFTS_GIFTS_AND_GIFTS ? (
        <Tabs
          id="customization"
          variant="secondary"
          listOfSections={LIST_OF_SECTIONS}
        />
      ) : (
        <Message />
      )}
    </div>
  );
}

const mapStateToProps = ({ giftTable }) => ({
  tableInfo: giftTable.giftTableInfo.data,
});

export default compose(
  withAgentPage(),
  withStore({ mapStateToProps })
)(Customization);